import React from 'react';
import pluralize from 'util/pluralize';
import styled from 'styled-components';

interface Requirement {
  credits: string | number;
  parentName: string;
  name?: string;
}

interface CLELibraryRequirementsProps {
  requirements: Requirement[];
  color?: string;
  className?: string;
}

export const CLELibraryRequirements = ({
  requirements,
  color,
  className,
}: CLELibraryRequirementsProps) =>
  requirements.length > 0 &&
  requirements.map(({ credits, parentName, name }, i) => (
    <StyledRequirement
      key={`${parentName}${credits}${i}`}
      className={className || ''}
    >
      <StyledRequirementBubble color={color}>
        {credits} {pluralize(credits, 'Hr')}
      </StyledRequirementBubble>
      {parentName === 'Special Requirements' ? name : parentName}
    </StyledRequirement>
  ));

interface StyledRequirementBubbleProps {
  color?: string;
}

export const StyledRequirementBubble = styled.span.attrs<StyledRequirementBubbleProps>(
  ({ color = 'var(--COLOR_COOL_BLUE)' }) => ({
    color,
  }),
)`
  display: inline-block;
  font-family: var(--FONT_SANS_SERIF);
  font-size: 12px;
  font-weight: 900;
  padding: 2px 7px;
  border-radius: 3px;
  background-color: ${({ color }) => color};
  color: var(--COLOR_WHITE);
  margin-right: 8px;
  margin-bottom: 8px;
`;

export const StyledRequirement = styled.div`
  display: inline-block;
  font-family: var(--FONT_SANS_SERIF);
  font-size: 14px;
  margin-right: 8px;
  white-space: nowrap;
`;
